import React from 'react';
import './App.css';
import FooterComponent from 'components/organisms/footer';
import HeaderNav from 'components/organisms/HeaderNav';
import { Route, Switch } from 'react-router';
import paths from 'paths';
import Home from 'components/pages/Home';
import Tool from 'components/pages/Tool';
import NotFound from 'components/pages/NotFound';

const App = () => {
  return (
    <div className="App">
      <HeaderNav />
      <main>
        <Switch>
          <Route path={paths.tool} component={Tool} />
          <Route exact path={paths.home} component={Home} />
          <Route path="*" component={NotFound} />
        </Switch>
      </main>
      <FooterComponent />
    </div>
  );
};

export default App;
